import React, { useState }  from "react"
import axios from "axios";
import { Link } from "gatsby"

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Button, FormGroup, Input, Label, Modal, ModalBody } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowCircleRight } from "@fortawesome/free-solid-svg-icons";
import { UtmContext } from "../../utils/utmContext";

const MyForm = () => {

  const [modal, setModal] = React.useState(false)

  const { utm } = React.useContext(UtmContext);

  const toggle = () => setModal(!modal)

    const [serverState, setServerState] = useState({
      submitting: false,
      status: null
    });
    const handleServerResponse = (ok, msg, form) => {
      setServerState({
        submitting: false,
        status: { ok, msg }
      });
      if (ok) {
        toggle();
        toast["success"]( (<p>Thanks!</p>) );
        form.reset();
      }
    };
    const handleOnSubmit = e => {
      e.preventDefault();
      const form = e.target;
      setServerState({ submitting: true });
      axios({
        method: "post",
        url: "https://getform.io/f/2254c858-6eef-4081-8bd8-92677ce564e1",
        data: new FormData(form)
      })
        .then(r => {
            handleServerResponse(true, "Thanks!", form);
            // toast["success"]( (<p>Thanks, we will get back to you as soon as we can!</p>) );
            // toggle();
            window.dataLayer.push({
                event: 'conactFormComplete'
            });
        })
        .catch(r => {
          handleServerResponse(false, r.response.data.error, form);
          toast["error"]( (<p>an Error, occurred please refresh the page and try again</p>) );
        });
    };
    return (
      <>
      <ToastContainer position={toast.POSITION.TOP_CENTER}  />
            <form onSubmit={handleOnSubmit}>
            <input type="hidden" name="utm" value={utm}  aria-label="hidden utm field"/>
            <div className="form-group">
                <label htmlFor="name">First name</label>
                <input type="text" name="name" className="form-control name" id="name" aria-label="Enter your name" placeholder="Enter your name" required="required"/>
            </div>
            <div className="form-group">
                <label htmlFor="email" required="required">Email address</label>
                <input type="email" name="email" className="form-control email" id="email" aria-label="Enter email" aria-describedby="emailHelp" placeholder="Enter email" required="required"/>
            </div> 
            <div className="form-group">
                <label htmlFor="url" required="required">Your website URL</label>
                <input type="url" name="url" className="form-control email" id="email" aria-label="Your website URL" aria-describedby="emailHelp" placeholder="https://brillea.com" required="required"/>
            </div> 
            <FormGroup>
              <Label htmlFor="EcommercePlatform">Which Ecommerce platform do you use?</Label>
              <Input type="select" name="EcommercePlatform" id="EcommercePlatform" required="required">
                <option>Shopify</option>
                <option>WooCommerce</option>
                <option>Wix</option>
                <option>Squarespace</option>
                <option>Other</option>
              </Input>
            </FormGroup>
            <div className="form-group">
                <label htmlFor="enquiry">How can we help?</label>
                <textarea style={{minHeight:"140px"}} name="enquiry" className="form-control enquiry" id="enquiry" aria-label="Enter your enquiry" placeholder="Let us know a bit about your store, where you're at and what you'd like to achieve with your marketing." required="required"
                ></textarea>
            </div>
            <div>
                <button type="submit" className="btn btn-secondary"  disabled={serverState.submitting}>
                    Let's do this
                </button>
            </div>
            {serverState.status && (
                <p className={!serverState.status.ok ? "errorMsg" : "thanksMsg"}>
                {serverState.status.msg}
                </p>
            )}
            </form>

            <Modal isOpen={modal} toggle={toggle}>
              <ModalBody className="text-center pt-5 pb-5">
                <h2>We'll be in touch</h2>
                <p>Thanks for your enquiry. A member of our<br/> team will be in touch via email shortly.</p>
                <p>There might be something useful in our FAQs.</p>
                <Button 
                  tag={Link} to={"/faqs/"}
                  color="link"
                  size="lg"
                  className="btn-link-purple mt-3"
                  >See all frequently asked questions <FontAwesomeIcon icon={faArrowCircleRight} /></Button>
              </ModalBody>
            </Modal>
      </> 
         
    );
  };
  
  export default MyForm;